export const imageSizeClassMap = {
  default: "w-16 lg:w-28",
  sm: "w-8 lg:w-11",
};

export type ImageSize = keyof typeof imageSizeClassMap;
